module.exports = __webpack_public_path__ + "static/media/logout1.c94ce9ac.svg";